import { createFeatureSelector } from '@ngrx/store';

export const menuFlowDefaultActivationsState = createFeatureSelector<OLO.State, OLO.State.MenuFlowDefaultActivations[]>('menuFlowDefaultActivations');
